import React from 'react';
import { StyledBannerShelfzone } from './StyledBannerShelfzone';
import { useLocation,useHistory } from 'react-router-dom';

import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

const BannerShelfzone = ({ subtitle, text, route, copyRoute, black, isDownload, isExternal }) => {

  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true));

      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
    
  }
  return (
    <React.Fragment>
      {
       
          <StyledBannerShelfzone>
            <div className="banner--content">
              <div className="banner--col banner--col-text">
              <p className="preset-13 banner-subtitle" style={{color: black ? black : '#fff'}}>{subtitle}</p>
                <h5 className="big--title" style={{color: black ? black : '#fff'}}>
                  {text}
                </h5>
                {
                    isDownload ?
                    <div className="cta--primary cursor-cta">
                      <a className="cursor-cta" href={route} target="_blank">
                        <p className="preset-10 cursor-cta" style={{color: black ? black : '#45B865'}} >{copyRoute}</p>
                        {
                          isExternal ?
                          <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke={black ? black : '#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                            <path className="cursor-cta" d="M13 6H1" stroke={black ? black : '#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          :
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path className="cursor-cta" d="M5 13L12 21L19 13" stroke="#45B865" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                            <path className="cursor-cta" d="M12 21V3" stroke="#45B865" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        }
                      </a>
                    </div>
                    :
                    <div className="cta--primary cursor-cta" onClick={()=> handleCLick(route)}>
                      <p className="preset-10 cursor-cta" style={{color: black ? black : '#45B865'}} >{copyRoute}</p>
                        <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke={black ? black : '#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                          <path className="cursor-cta" d="M13 6H1" stroke={black ? black : '#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                }
              </div>
              <div className="banner--col banner--col-image" style={{backgroundImage: `url( ${require('../../assets/banner-shelfzone.jpg')}) ` }} >
                
              </div>
            </div>
            
          </StyledBannerShelfzone>
          
      }
    </React.Fragment>
  );
};

export default BannerShelfzone;
